import { useState, useMemo } from 'react';

interface UseSorting<T> {
  sortedItems: T[];
  sortOrder: 'asc' | 'desc';
  toggleSortOrder: () => void;
}

export const useSorting = <T>(
  items: T[],
  getKey: (item: T) => string
): UseSorting<T> => {
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');

  const toggleSortOrder = () => {
    setSortOrder(prevOrder => (prevOrder === 'asc' ? 'desc' : 'asc'));
  };

  const sortedItems = useMemo(
    () =>
      [...items].sort((a, b) => {
        const keyA = getKey(a).toLowerCase();
        const keyB = getKey(b).toLowerCase();

        return (keyA > keyB ? 1 : -1) * (sortOrder === 'asc' ? 1 : -1);
      }),
    [items, sortOrder, getKey]
  );

  return {
    sortedItems,
    sortOrder,
    toggleSortOrder,
  };
};
